import * as React from "react";

export const ToggleClientSwitchEnabled = () => (
  <svg width="40" height="20" viewBox="0 0 40 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: "14px" }}>
    <rect width="40" height="20" rx="10" fill="#5B5FC7" />
    <circle cx="30" cy="10" r="7" fill="white" />
  </svg>
);

export const ToggleClientSwitchDisabled = () => (
  <svg width="40" height="20" viewBox="0 0 40 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: "14px" }}>
    <rect x="0.5" y="0.5" width="39" height="19" rx="9.5" stroke="white" />
    <circle cx="10" cy="10" r="7" fill="white" />
  </svg>
);
